import { render, staticRenderFns } from "./Beverages.vue?vue&type=template&id=ea484e7e&scoped=true&"
import script from "./Beverages.vue?vue&type=script&lang=js&"
export * from "./Beverages.vue?vue&type=script&lang=js&"
import style0 from "./Beverages.vue?vue&type=style&index=0&id=ea484e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea484e7e",
  null
  
)

export default component.exports